module.exports = __webpack_public_path__ + "img/logo-dhl.8ded9066.svg";